export const addresses = [
  {
    id: 'main',
    name: '官方主域名',
    url: 'https://www.official-site.com',
    type: 'primary',
    status: 'online',
    speed: '快速',
    region: '全球',
    badge: '推荐',
  },
  {
    id: 'backup-cn',
    name: '国内备用域名',
    url: 'https://www.official-site.cn',
    type: 'backup',
    status: 'online',
    speed: '极速',
    region: '中国大陆',
    badge: '国内首选',
  },
  {
    id: 'hd',
    name: '华东节点',
    url: 'https://hd.official-site.com',
    type: 'backup',
    status: 'online',
    speed: '极速',
    region: '华东地区',
    badge: '',
  },
  {
    id: 'hn',
    name: '华南节点',
    url: 'https://hn.official-site.com',
    type: 'backup',
    status: 'online',
    speed: '快速',
    region: '华南地区',
    badge: '',
  },
  {
    id: 'hb',
    name: '华北节点',
    url: 'https://hb.official-site.com',
    type: 'backup',
    status: 'online',
    speed: '快速',
    region: '华北地区',
    badge: '',
  },
  {
    id: 'xn',
    name: '西南节点',
    url: 'https://xn.official-site.com',
    type: 'backup',
    status: 'online',
    speed: '较快',
    region: '西南地区',
    badge: '',
  },
  {
    id: 'backup-intl',
    name: '国际备用域名',
    url: 'https://www.official-site.org',
    type: 'backup',
    status: 'online',
    speed: '较快',
    region: '海外',
    badge: '',
  },
  {
    id: 'emergency',
    name: '紧急备用地址',
    url: 'https://emergency.official-site.com',
    type: 'emergency',
    status: 'standby',
    speed: '一般',
    region: '全球',
    badge: '紧急',
  },
];

export const stats = {
  totalVisits: 2580000,
  onlineNodes: 7,
  uptime: '99.93%',
  updateCount: 128,
  onlineDays: 365,
  usersServed: 156000,
};